import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import {
  ClientAttachmentHistory,
  ClientAttachmentHistoryRequest,
  ClientAttachmentHistoryResponse,
} from './types'
import { $params } from '../../../../features/router'
import { RequestError } from '../../../../shared/errorResponse'
import { getBonusAccounts, setAccountsRequestError } from '../bonus/model'

export const clientAttachmentHistoryMounted =
  createEvent<ClientAttachmentHistoryRequest>()

export const setClientAttachmentHistoryRequestError =
  createEvent<RequestError>()

export const getClientAttachmentHistory = fx<
  ClientAttachmentHistoryRequest,
  ClientAttachmentHistoryResponse
>({
  method: 'GET',
  url: '/client/{clientId}/attachment_history',
})

export const $clientAttachmentHistory = restore<ClientAttachmentHistory[]>(
  getClientAttachmentHistory.doneData.map((doneData) => doneData.body.items),
  [],
)

export const $totalCountOfClientAttachmentHistory = restore(
  getClientAttachmentHistory.doneData.map((a) => a.body.total),
  0,
)

export const $errorClientAttachmentHistoryRequest = restore(
  setClientAttachmentHistoryRequestError,
  {
    message: '',
    code: 0,
  },
)

sample({
  clock: clientAttachmentHistoryMounted,
  fn: ({ limit, page }) => {
    let state = $params.getState()
    let query = {
      limit: String(limit),
      page: String(page),
      order: '-id',
      populate: JSON.stringify(['ClientAttachmentHistory.createdBy']),
    }
    return {
      query,
      url: `/client/${state?.clientID}/attachment_history`,
    }
  },
  target: getClientAttachmentHistory,
})

sample({
  clock: getClientAttachmentHistory.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setClientAttachmentHistoryRequestError],
})
